//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import * as d3 from "d3";
import d3Locale from "d3-format/locale/en-US.json";
import { csvGenerator } from "@/utils/csvGenerator.js";


const DEFAULT_FORMAT = (value) =>
  value != null && value != undefined ? value : "N/A";

function formatNumber(num) {
  if (num !== null && num.toString().includes(".")) {
    return d3.format(",.2f")(num);
  } else {
    return d3.format(",")(num);
  }
}

export default {
  name: "GraphTable",
  props: ["tableClass", "data", "context"],
  components: {
    Table,
  },
  mounted: function () {
    d3Locale.thousands = " "
    d3Locale.nan = "N/A"
    d3.formatDefaultLocale(d3Locale);
  },
  data: () => ({
    separator: "horizontal",
    recordsTotal: 0,
    tableData: [],
    columns: [],
  }),
  methods: {
    exportData: function () {
      let exportContent = [];
      exportContent.push(this.columns.map(e => e.label))
      let data = this.tableData.map(e => Object.values(e))
      exportContent = exportContent.concat(data)

      csvGenerator.toCSV('tableExport.csv', exportContent);
    }
  },
  watch: {
    data: {
      immediate: true,
      handler: function () {
        this.tableData = [];
        this.recordsTotal = this.data.mainData.length;
        if (this.context == "YTD" || this.context == "MTD") {
          this.columns = [];
        } else {
          this.columns = [
            {
              name: "label",
              required: false,
              label: this.context ? this.context : "Índice",
              align: "left",
              field: (row) => (row.label ? row.label : "N/A"),
              format: DEFAULT_FORMAT,
              sortable: false,
            },
          ];
        }
        let lineVariation = null;
        for (let i = 0; i < this.data.mainData.length; i++) {
          if (!this.columns.some(e => e.label == this.data.mainData[i].year)) {
            this.columns.push({
              name: "label-cy",
              required: false,
              label: "" + this.data.mainData[i].year,
              align: "left",
              field: (row) => (row.valueMain ? row.valueMain : "N/A"),
              format: DEFAULT_FORMAT,
              sortable: false,
            })
          }

          if (!this.columns.some(e => e.label == this.data.secondaryData[i].year)) {
            this.columns.push({
              name: "label-py",
              required: false,
              label: "" + this.data.secondaryData[i].year,
              align: "left",
              field: (row) => (row.valueSecondary ? row.valueSecondary : "N/A"),
              format: DEFAULT_FORMAT,
              sortable: false,
            })
          }

          lineVariation = this.data.lineData.find(e => e[0] === i);

          this.tableData.push({
            label: this.data.mainData[i].label,
            valueMain: formatNumber(this.data.mainData[i].value),
            valueSecondary: formatNumber(this.data.secondaryData[i].value),
            variation: lineVariation ? formatNumber(lineVariation[1]) : ''
          })

          lineVariation = null;
        }

        this.columns.push({
          name: "Variation",
          required: false,
          label: "Variação",
          align: "left",
          field: (row) => (row.variation ? row.variation : "N/A"),
          format: DEFAULT_FORMAT,
          sortable: false,
        })
      },
    },
  }
};
